const moment = require("moment");

const helpers = {
  formatDate: (date, format = "D MMM YYYY") => { 
    return moment(date).format(format);
  },

  getTimeAgo: (timestamp) => {
    const now = new Date();
    const updated = new Date(timestamp);
    const diff = Math.floor((now - updated) / 1000); // in seconds

    if (diff < 5) return "just now";
    if (diff < 60) return `${diff} second${diff > 1 ? "s" : ""} ago`;

    const minutes = Math.floor(diff / 60);
    if (minutes < 60) return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;

    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} hour${hours > 1 ? "s" : ""} ago`;

    const days = Math.floor(hours / 24);

    if (days > 2) {
      return helpers.formatDate(timestamp); // 👈 use the object reference instead of `this`
    }

    return `${days} day${days > 1 ? "s" : ""} ago`;
  },

  getDateAgo: (timestamp) => {
    const now = new Date();
    const updated = new Date(timestamp);

    // Strip time part for comparison
    const nowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const updatedDate = new Date(
      updated.getFullYear(),
      updated.getMonth(),
      updated.getDate()
    );

    const diffTime = nowDate - updatedDate;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    if (diffDays === 0) {
      return "Today";
    } else if (diffDays === 1) {
      return "Yesterday";
    } else {
      return helpers.formatDate(timestamp); // or formatDate if using functional style
    }
  },
};

module.exports = helpers;
